import { StorageNamesEnum } from 'CorePackage/MainModule/enums/StorageNamesEnum';
import { getStorageItem, setStorageItem } from 'CorePackage/MainModule/common/localStore';

import { IAgreementListFilterState } from '../interfaces/IAgreementListFilterState';
import { AgreementListFilterActionsEnum } from '../enums/AgreementListFilterActionsEnum';
import { IAgreementListFilterWithMeta } from '../interfaces/IAgreementListFilterWithMeta';
import { AgreementListFilterAction } from '../types/AgreementListFilterAction';

const initialState: IAgreementListFilterState = {
  current: getStorageItem(StorageNamesEnum.AGREEMENT_LIST_FILTER),
  isFilterOn: !!getStorageItem(StorageNamesEnum.AGREEMENT_LIST_FILTER_ON),
  filters: [],
};

export function agreementListFilterReducer(state = initialState, action: AgreementListFilterAction) {
  switch (action.type) {
    case AgreementListFilterActionsEnum.AGREEMENT_LIST_FILTER_SET_CURRENT: {
      const { current, currentId } = action.payload;
      const newState: IAgreementListFilterState = {
        ...state,
        current,
        currentId,
      };

      setStorageItem(StorageNamesEnum.AGREEMENT_LIST_FILTER, current);

      return newState;
    }
    case AgreementListFilterActionsEnum.AGREEMENT_LIST_FILTER_SET_SWITCHER: {
      const { value: isFilterOn } = action.payload;
      const newState: IAgreementListFilterState = {
        ...state,
        isFilterOn,
      };

      setStorageItem(StorageNamesEnum.AGREEMENT_LIST_FILTER_ON, isFilterOn);

      return newState;
    }
    case AgreementListFilterActionsEnum.AGREEMENT_LIST_FILTER_SET_PLAN_NUM: {
      const { planNum } = action.payload;
      const newState: IAgreementListFilterState = {
        ...state,
        planNum,
      };

      return newState;
    }
    case AgreementListFilterActionsEnum.AGREEMENT_LIST_FILTER_SET_META: {
      const filters = action.payload.list.map<IAgreementListFilterWithMeta>(meta => ({ meta }));
      const newState: IAgreementListFilterState = {
        ...state,
        filters,
      };

      return newState;
    }
    case AgreementListFilterActionsEnum.AGREEMENT_LIST_FILTER_REMOVE: {
      const { id } = action.payload;
      const filters = state.filters.filter(f => f.meta.id !== id);
      const newState: IAgreementListFilterState = {
        ...state,
        filters,
      };

      return newState;
    }
    case AgreementListFilterActionsEnum.AGREEMENT_LIST_FILTER_SET_DATA: {
      const { id, data } = action.payload;
      const filters = state.filters.map<IAgreementListFilterWithMeta>(filter => {
        if (filter.meta.id === id) {
          return {
            ...filter,
            data,
            meta: {
              ...filter.meta,
              id,
              name: data.name,
            },
          };
        }

        return filter;
      });
      const newState: IAgreementListFilterState = {
        ...state,
        filters,
      };

      return newState;
    }
    default:
      return state;
  }
}
